export default __webpack_public_path__ + "cocoa_doorbell_v4.28d2cab9.png";